import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation, Trans } from 'react-i18next'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import TwoCol from '../../partials/TwoCol'
import '../../sass/innerPages.sass'
import MainTitle from '../../partials/MainTitle'
import bakery from '../../img/bakery.jpg'
import persona from '../../img/persona.jpg'
import journey from '../../img/journey.jpg'
import flow from '../../img/flow.jpg'
import screens1 from '../../img/screens1.jpg'
import screens2 from '../../img/screens2.jpg'
import screens3 from '../../img/screens3.jpg'

function Bakery() {
  const { t } = useTranslation();
  const bakeryLoFi = "https://www.figma.com/proto/qnsFX5N9rb0w8C9U06Xe6N/Food-delivery-app-for-bakery?page-id=0%3A1&node-id=18-2&p=f&viewport=678%2C355%2C0.25&t=9FjXJk7SgWGVOvYd-1&scaling=scale-down&content-scaling=fixed&starting-point-node-id=18%3A2";
  const bakeryHiFi = "https://www.figma.com/proto/fVXuRDPmAkfdUHodosry2H/M3-Food-delivery-app?page-id=53098%3A27267&type=design&node-id=53372-28903&viewport=449%2C459%2C0.32&t=KsK9blO0wK5jsWFA-1&scaling=scale-down&starting-point-node-id=53372%3A28903";

  useEffect(()=>{
    window.scrollTo(0, 0);
  },[])

  return (
    <div className='container'>
      <MainTitle title={t('bakeryTitle')} />
      <TwoCol contentOne={<ContentOne />} contentTwo={<ContentTwo />} />
      <div className='txtContainer mt-50 px-20'>
        <h2>Persona</h2>
        <p>{t('bakeryPersonaTxt')}</p>
        <figure>
          <img className="image-fluid" src={persona} alt="Persona" />
          <figcaption>{t('bakeryPersonaCaption')}</figcaption>
        </figure>
      </div>
      <div className='txtContainer mt-50 px-20'>
        <h2>{t('bakeryCA')}</h2>
        <p><Trans i18nKey="bakeryCATxt">
          Auditing the competition revealed many shortcomings and advantages that helped us in designing our application. Main competitors:
        </Trans></p>
        <ul>
          <li>Dubravica</li>
          <li>Pan-Pek</li>
          <li>Mlinar</li>
        </ul>
      </div>
      <div className='txtContainer mt-50 px-20'>
        <h2>{t('UJ')}</h2>
        <p>{t('bakeryUJTxt')}</p>
        <figure>
          <img className='image-fluid' src={journey} alt={t('bakeryUJ')} />
          <figcaption>{t('bakeryUJCaption')}</figcaption>
        </figure>
      </div>
      <div className='txtContainer mt-50 px-20'>
        <h2>{t('bakeryUF')}</h2>
        <p>{t('bakeryUFTxt')}</p>
        <figure>
          <img className='image-fluid' src={flow} alt={t('bakeryUF')} />
          <figcaption>{t('bakeryUFCaption')}</figcaption>
        </figure>
      </div>
      <div className='txtContainer mt-50 px-20'>
        <h2>{t('wireframesLF')}</h2>
        <p>{t('bakeryLFTxt')}</p>
        <iframe id="bakeryLFPrototype" title="bakeryLFPrototype" style={{border: "1px solid rgba(0, 0, 0, 0.1)"}} width="100%" height="650" src="https://embed.figma.com/proto/qnsFX5N9rb0w8C9U06Xe6N/Food-delivery-app-for-bakery?page-id=0%3A1&node-id=18-2&p=f&viewport=422%2C230%2C0.38&scaling=scale-down&content-scaling=fixed&starting-point-node-id=18%3A2&embed-host=share" allowfullscreen></iframe>
        <Link className="btn btn-link btn-inner" to={bakeryLoFi} target="_blank">{t('seeLFPrototype')}</Link>
      </div>
      <div className='txtContainer mt-50 px-20'>
        <h2>{t('designHF')}</h2>
        <p>{t('bakeryHFTxt')}</p>
        <Tabs className="tabContainer">
          <TabList>
          <Tab>Scr1</Tab>
          <Tab>Scr2</Tab>
          <Tab>Scr3</Tab>
          </TabList>

          <TabPanel>
              <div>
                  <img className='image-fluid' src={screens1} alt="Hi-Fi mockups" />
              </div>
          </TabPanel>
          <TabPanel>
              <div>
                  <img className='image-fluid' src={screens2} alt="Hi-Fi mockups" />
              </div>
          </TabPanel>
          <TabPanel>
              <div>
                  <img className='image-fluid' src={screens3} alt="Hi-Fi mockups" />
              </div>
          </TabPanel>
        </Tabs>
      </div>
      <div className='txtContainer mt-50 px-20'>
        <h2>{t('UT')}</h2>
        <p>{t('bakeryUTTxt')}</p>
        <iframe id="bakeryHFPrototype" title="bakeryHFPrototype" style={{border: "1px solid rgba(0, 0, 0, 0.1)"}} width="100%" height="650" src="https://embed.figma.com/proto/fVXuRDPmAkfdUHodosry2H/M3-Food-delivery-app?page-id=53098%3A27267&node-id=53372-28903&p=f&viewport=399%2C386%2C0.13&scaling=scale-down&content-scaling=fixed&starting-point-node-id=53372%3A28903&embed-host=share" allowfullscreen></iframe>
        <Link className="btn btn-link btn-inner" to={bakeryHiFi} target="_blank">{t('seeHFPrototype')}</Link>
      </div>
    </div>
  )
}

export default Bakery

function ContentOne() {
  return (
    <img className="image-fluid" src={bakery} alt="Bakery App" />
  )
}

function ContentTwo() {
  const { t } = useTranslation();
  const seePrototype = "https://www.figma.com/proto/fVXuRDPmAkfdUHodosry2H/M3-Food-delivery-app?page-id=53098%3A27267&type=design&node-id=53372-28903&viewport=449%2C459%2C0.32&t=KsK9blO0wK5jsWFA-1&scaling=scale-down&starting-point-node-id=53372%3A28903";

  return (
    <div className='innerMain mx-50'>
      <p className='mt-0'><Trans i18nKey="bakeryMainText">
        A simple android mobile app based on <strong>Material Design system</strong>. The app offers various bakery products for ordering and collecting bonuses. It also has delivery and payment. This was a personal project and the whole content is purely presentational.
      </Trans></p>
      <Link className="btn btn-link mt-20" to={seePrototype} target="_blank">{t('seePrototype')}</Link>
      <h2 className='mt-50 mb-0'>{t('mainProblem')}</h2>
       <p className='problem'><Trans i18nKey="bakeryMainText2">
        The main problem to solve was: <br/><i>How to best present products and enable users to order quickly and easily.</i>
      </Trans></p>
    </div>
  )
}

